/**
 * NEON OVERPASS — cartridge palette.
 *
 * '84 vaporwave-arcade: magenta horizon, cyan-and-yellow neon striping, deep
 * dusk sky, yellow player. The road uses LIGHT/DARK pairs for the segment
 * striping classic to OutRun-style projection; rumble strips alternate red
 * and white. Fog at the horizon interpolates toward FOG_COLOR.
 *
 * PALETTE_HINT is what the cabinet samples for marquee tinting during launch.
 */

export const FOG_COLOR = '#1a0840';
export const SKY_TOP = '#0a0418';
export const SKY_HORIZON = '#5a1a78';
export const SUN = '#ff3c8a';
export const MOUNTAIN_FAR = '#3a1058';
export const MOUNTAIN_NEAR = '#1f0838';

export const ROAD_LIGHT = { road: '#3a3050', rumble: '#ffea00', grass: '#3a126a', lane: '#f5e6ff' } as const;
export const ROAD_DARK = { road: '#332945', rumble: '#ff0066', grass: '#2e0a58', lane: null as string | null } as const;
export const ROAD_START = { road: '#ffffff', rumble: '#ffffff', grass: '#3a126a', lane: null as string | null } as const;
export const ROAD_FINISH = { road: '#0a0a0a', rumble: '#0a0a0a', grass: '#3a126a', lane: null as string | null } as const;

export const PLAYER_BODY = '#ffea00';
export const PLAYER_BODY_DARK = '#7a6f00';
export const PLAYER_BODY_LIGHT = '#fff89a';
export const PLAYER_WINDOW = '#00d9ff';
export const PLAYER_WINDOW_HI = '#bff7ff';
export const PLAYER_TAIL = '#ff3030';

export const TRAFFIC_MAGENTA = '#ff00aa';
export const TRAFFIC_CYAN = '#00d9ff';
export const TRAFFIC_GREEN = '#27e060';
export const TRAFFIC_PURPLE = '#9a3cff';
export const TRAFFIC_SHADOW = '#000000';

export const SPRITE_PALM_TRUNK = '#5b3a1c';
export const SPRITE_PALM_FRONDS = '#0a8030';
export const SPRITE_PALM_HI = '#4cd070';
export const SPRITE_SIGN_YELLOW = '#ffea00';
export const SPRITE_SIGN_BORDER = '#000000';
export const SPRITE_SIGN_POST = '#7a5028';
export const SPRITE_NEON_PINK = '#ff3c8a';
export const SPRITE_NEON_CYAN = '#00d9ff';

export const HUD_TEXT = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_SPEED = '#ff3030';
export const HUD_TURBO = '#ff00aa';

export const CRASH_FLASH = '#ff3030';

/** Tokens the cabinet samples for marquee tinting while this cartridge is loaded. */
export const PALETTE_HINT: readonly string[] = [
  PLAYER_BODY,
  TRAFFIC_MAGENTA,
  TRAFFIC_CYAN,
  SUN,
];
